$('.header__search-box').on('click', function () {
    $('.fullscreen-search-modal').addClass('active');
    $('html').addClass('hidden-scroll');
    $(".mobile-menu").removeClass("active");
    $(".mobile-menu-opener").addClass("collapsed");
    $("body").removeClass("-overflow");
});

$('.close-modal, .search-form-wrap-overlay').on('click', function () {
    $('.fullscreen-search-modal').removeClass('active');
    $('html').removeClass('hidden-scroll');
});

$(".mobile-menu a").each(function( index ) {
    let css_delay = ((index + 1) * .05) + 0.3;
    $(this).css("animation-delay", css_delay+"s");
});

$(".mobile-menu-opener").on("click", function () {
    $(this).toggleClass("collapsed");
    $(".mobile-menu").toggleClass("active");
    $("body").toggleClass("-overflow");
});
